import React, { useState, useEffect, useRef } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import VerificationInputField from "components/VerificationInputField";
import ModalGeneralSuccessfully from "screens/ModalGeneralSuccessfully";
import { useMutation } from "@apollo/client";
import { VERIFY_NEW_CONTACT } from "graphql/service";
import { Head, Container, Footer } from "./styles";

const ModalVerification = ({
  hidden,
  isOpen,
  setClose,
  refetch,
  token,
  email,
  phoneNumber,
  retry
}) => {

  const verificationInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (verificationInputRef.current) {
          verificationInputRef.current.focusFirst();
        }
      }, 50); 
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState(["", "", "", "", "", ""]);
  const [verificationCodeError, setVerificationCodeError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [verifyNewContact, { loading }] = useMutation(VERIFY_NEW_CONTACT, {
    onCompleted: () => {
      setClose();
      setSuccessfullyIsOpen(true);
      setVerificationCode(["", "", "", "", "", ""]);
      setErrorMessage("");
    },
    onError: (error) => {
      setVerificationCodeError(true);
      let message;
      if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        // 2. Loop through the errors or target the first one
        error.graphQLErrors.forEach(({ extensions }) => {
          const errorCode = extensions?.code;
          if (errorCode) {
            switch (errorCode) {
              case "CONTACT_VERIFICATION_INVALID":
                message = "The verification code is invalid. Please try again.";
                break;
              case "CONTACT_VERIFICATION_ALREADY_CONSUMED":
                message = "This verification code has already been used. Please request a new code using the resend code link below.";
                break;
              case "CONTACT_VERIFICATION_EXPIRED":
                message = "The verification code has expired. Please request a new code using the resend code link below.";
                break;
              default: 
                message = "An error occurred. Please try again.";
            }
          } else {
            message = "An error occurred. Please try again.";
          }
        });
      } else if (error.networkError) {
        message = error.networkError.message || "A network error occurred. Please try again.";
      } else {
        message = "An error occurred. Please try again.";
      }
      setErrorMessage(message);
    }
  })

  const handleVerify = () => {
    if (verificationCode.length !== 6) {
      setVerificationCodeError(true);
      return;
    }
    if (email) {
    verifyNewContact({
      variables: {
        input: {
          contactType: "EMAIL",
          sessionToken: token,
          code: verificationCode.join(''),
          newValue: email
        },
      },
    });
    } else if(phoneNumber) {
      verifyNewContact({
        variables: {
          input: {
            contactType: "PHONE",
            sessionToken: token,
            code: verificationCode.join(''),
            newValue: phoneNumber
          },
        },
      });
    } else {
      return;
    }
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setClose={() => {
          setClose()
          setVerificationCode(["", "", "", "", "", ""])
          setVerificationCodeError(false)
          setErrorMessage("")
        }}
        className="modal-success"
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Confirmation Required</Head>
        <Container>
          <div className="modalText">{`A verification code has been sent to your new ${email? ('email address '+ email): ('phone number ending in '+ phoneNumber?.slice(-4))}. Please enter the code below to confirm your update:`}</div> 
          <VerificationInputField
            ref={verificationInputRef}
            title="VERIFICATION CODE"
            required
            width="320px"
            length={6}
            values={verificationCode}
            setValues={(values) => {
              setVerificationCode(values)
              setVerificationCodeError(false)
              setErrorMessage("")
            }}
            error={verificationCodeError}
            errorMessage={errorMessage}
            margin="16px 0 24px 0"
          />
          <Footer>
            <Button
              success
              additionalstyle={`
                width: ${email? '183px': '187px'};
              `}
              onClick={handleVerify}
              data-loading={loading}
            >
              {loading ? null : email? "Verify Email Address": "Verify Phone Number"}
            </Button>
          </Footer>
          <div className="modalText">
            <span>{`Haven’t received the code? `}</span>
            <span
              className='highLight'
              onClick={retry}
            >
              Resend code
            </span>
          </div>
        </Container>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        type="verification"
        callback={refetch}
      />
    </>
  );
};

export default ModalVerification;
